import { FC, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { appStore } from '../../../state';
import { Copy, ROUTES } from '../../../types';

interface PaymentFailureProps extends Copy {}

const PaymentFailure: FC<PaymentFailureProps> = ({
  fallbackCopy,
  localeCopy,
}) => {
  const history = useHistory();
  const { dispatch } = useContext(appStore);

  useEffect(() => {
    dispatch({
      type: 'ADD_MESSAGE',
      payload: {
        dismissable: true,
        id: new Date().getTime(),
        text: localeCopy?.PAYMENT_FAILED || fallbackCopy.PAYMENT_FAILED,
        timeout: 7,
        type: 'error',
      },
    });

    history.replace(ROUTES.PAYMENT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default PaymentFailure;
